import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useAuthUser } from "souqh-react-redux-hooks/useLogin";

function SecuredRoute({ children, ...rest }) {
  const user = useAuthUser();
  return (
    <Route
      {...rest}
      render={({ location }) =>
        user ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/", // always land to home page as there are two login pages HB and SP and we exactly dont know from where user has come
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

export default SecuredRoute;
